<main class="root-container">
    <section class="page">
        <div class="page-content-full">
            <router-outlet></router-outlet>
        </div>
    </section>
    <diana-loader></diana-loader>
</main>